import * as Enumeration from "./Enumeration";
import * as Constants from "./Constants";
import * as Classes from "./classes";
import * as Resources from "./Resources";

const MODULES = {
    Enumeration,
    Constants,
    Classes,
    Resources
}

export default MODULES; 